import { jsx as _jsx } from "react/jsx-runtime";
import { t } from '@/core/localization';
import { NavLink } from 'react-router-dom';
import { appSections } from '../appSections';
import { ProtectedRoute } from '../components';
const { rootPath, getLinkTo, title, groups } = appSections.packing;
export const packingRoute = {
    path: rootPath,
    // lazy: async () => {
    // 	const { Packing } = await import('@/warehouse/modules/packing');
    // 	return { Component: Packing };
    // },
    element: _jsx(ProtectedRoute, { groups: groups }),
    handle: {
        crumb: ({ params: { crossDockId } }) => _jsx(NavLink, { to: getLinkTo(crossDockId), children: title }),
    },
    children: [
        {
            index: true,
            lazy: async () => {
                const { Packing } = await import('@/warehouse/modules/packing');
                return { Component: Packing };
            },
        },
        {
            path: ':customerId/:legalId',
            lazy: async () => {
                const { PackingDetails } = await import('@/warehouse/modules/packing');
                return { Component: PackingDetails };
            },
            handle: {
                crumb: ({ params: { crossDockId, customerId, legalId } }) => {
                    return _jsx(NavLink, { to: `${getLinkTo(crossDockId)}/${customerId}/${legalId}`, children: t('counterparty.packing.label') });
                },
            },
        },
    ],
};
